import {
  Css_HeadingH4,
  HeadingH1,
  HeadingH4,
} from '@dreamstack/feature-components'
import type { FullBlockTableFragment } from '@dreamstack/investors-graphql'
import head from 'lodash/head'
import map from 'lodash/map'
import tail from 'lodash/tail'
import type { FunctionComponent } from 'react'
import tw, { styled } from 'twin.macro'

const StyledTd = styled.td(() => [tw`p-px-24`, Css_HeadingH4])

export const TableDefault: FunctionComponent<React.PropsWithChildren<{
  block: FullBlockTableFragment
}>> = ({ block }) => {
  const { table, title } = block
  const headData: string[] = head(table?.tableData) || []
  const rowData: string[][] = tail(table?.tableData) || [[]]
  return (
    <div tw="w-full mt-px-48 md:(mt-px-80)">
      {title && <HeadingH1 tw="mb-px-24">{title}</HeadingH1>}
      <div tw="w-full overflow-auto">
        <table tw="w-full">
          {!!headData?.length && (
            <thead>
              <tr tw="border-b-2 border-accentroGray-full font-semibold">
                {map(headData, (headDataEntry, i) => (
                  <th tw="text-left p-px-24" key={i}>
                    <HeadingH4>{headDataEntry}</HeadingH4>
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {map(rowData, (rowEntry, i) => (
              <tr key={i}>
                {map(rowEntry, (rowEntryData, i) => (
                  <StyledTd key={`rowdataentry${i}`}>{rowEntryData}</StyledTd>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
